module.exports = __webpack_public_path__ + "img/broom.cd662764.svg";